import BarraMenu from "../../../components/BarraMenu";
import useDigitalTheme from "../../hooks/useDigitalTheme";
import { useState, useEffect } from "react";
import { httpApiPostText } from "../../../lib";
import MsgDialog from "../../../components/MsgDialog";
import { FaRegHandPaper, FaCheck } from "react-icons/fa";
import "./style.css";
import API_HOST, { HEADERS_JSON } from "../../../ApiConfig";

// ── Helpers para reducir complejidad cognitiva (SonarQube T4) ─────────────────
const validateGuardarFields = (email: string, pass: string, confPass: string): string | null => {
  if (!email || !pass || !confPass) return "Los campos son obligatorios";
  const passRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
  if (!passRegex.test(pass)) return "La contraseña no cumple con los requisitos mínimos de seguridad";
  if (pass !== confPass) return "Las contraseñas no coinciden";
  return null;
};

const AdministracionUsuariosExternosPage = () => {
  useDigitalTheme();
  const [formData, setFormData] = useState({
    user_correo: "",
    user_pass: "",
    user_conf_pass: "",
  });
  const [passwordValid, setPasswordValid] = useState(false);
  const [userEmails, setUserEmails] = useState<string[]>([]);
  const [msgDlgShow, setMsgDlgShow] = useState(false);
  const [msgMensaje, setMsgMensaje] = useState("");
  const [msgDlgShowError, setMsgDlgShowError] = useState(false);
  const [msgMensajeError, setMsgMensajeError] = useState("");

  const validatePassword = (password: string): boolean => {
    const passRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
    return passRegex.test(password);
  };

  useEffect(() => {
    setPasswordValid(validatePassword(formData.user_pass));
  }, [formData.user_pass]);

  useEffect(() => {
    const fetchUserEmails = async () => {
      try {
        const response = await httpApiPostText(
          API_HOST,
          "POST",
          HEADERS_JSON,
          { valid: "allUser", logged_user_id: null, logged_user_profile: "Administrador", logged_user_business_group: null }
        );
        const data = JSON.parse(response.message);
        if (Array.isArray(data?.payload)) {
          const emailList = data.payload
            .map((user: any) => user?.user_email as string | undefined)
            .filter((email: string | undefined): email is string =>
              typeof email === "string" && email.trim() !== ""
            );
          const uniqueEmails = Array.from(new Set<string>(emailList)).sort((a, b) =>
            a.localeCompare(b, "es", { sensitivity: "base" })
          );
          setUserEmails(uniqueEmails);
        }
      } catch (error) {
        console.error("Error al cargar correos de usuarios", error);
      }
    };
    void fetchUserEmails();
  }, []);

  const textChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [event.target.id]: event.target.value });
  };

  // Refactorizada con validateGuardarFields (SonarQube T4: reducir complejidad)
  const guardar = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const normalizedEmail = formData.user_correo.trim().toLowerCase();
    const validationError = validateGuardarFields(normalizedEmail, formData.user_pass, formData.user_conf_pass);
    if (validationError) {
      setMsgMensajeError(validationError);
      setMsgDlgShowError(true);
      return;
    }
    try {
      const nObj = { ...formData, user_correo: normalizedEmail, valid: "updatePass" };
      const response = await httpApiPostText(API_HOST, "PUT", HEADERS_JSON, nObj);
      if (!response?.message) {
        setMsgMensajeError("Error de conexión al servidor");
        setMsgDlgShowError(true);
        return;
      }
      const dta = JSON.parse(response.message);
      if (dta.code === 1) {
        setMsgMensaje(dta.message);
        setMsgDlgShow(true);
        setFormData({ user_correo: "", user_pass: "", user_conf_pass: "" });
      } else {
        setMsgMensajeError(dta.message || "Error al actualizar la contraseña");
        setMsgDlgShowError(true);
      }
    } catch (error) {
      setMsgMensajeError("Error de conexión al servidor");
      setMsgDlgShowError(true);
    }
  };

  return (
    <>
      <div className="container bg-white">
        <BarraMenu />
        <div>
          <div className="text-secondary ms-3 mt-3 fw-bold">
            <h4>Adminstración de contraseñas</h4>
          </div>
        </div>
        <form className="row g-3 rounded shadow mt-3 mb-3" style={{ backgroundColor: "#DCDCDC" }}>
          <div className="container__password">
            <div className="col-12 mb-2">
              <label htmlFor="user_correo" className="form-label">Correo del usuario</label>
              <input
                className="form-control"
                id="user_correo"
                list="lista_correos"
                onChange={textChange}
                value={formData.user_correo}
                placeholder="Escriba o seleccione un correo..."
                autoComplete="off"
              />
              <datalist id="lista_correos">
                {userEmails.map((email) => (
                  <option key={email} value={email} />
                ))}
              </datalist>
            </div>

            <div className="col-12">
              <label htmlFor="user_pass" className="form-label">Nueva contraseña</label>
              <input
                type="password"
                className="form-control"
                id="user_pass"
                placeholder="Nueva contraseña"
                onChange={textChange}
                value={formData.user_pass}
              />
              <div className={`p-1 mt-1 rounded ${passwordValid ? "alert alert-success" : "alert alert-info"}`} role="alert">
                {passwordValid
                  ? <span><FaCheck className="mb-1 text-success" /> La contraseña cumple con todos los requisitos</span>
                  : <span><FaRegHandPaper className="mb-1 text-danger" /> La contraseña debe cumplir con: Mínimo 8 dígitos, una mayúscula, minúscula, un carácter especial y un número.</span>
                }
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="user_conf_pass" className="form-label">Confirmación contraseña</label>
              <input
                type="password"
                className="form-control"
                id="user_conf_pass"
                placeholder="Confirme nueva contraseña"
                onChange={textChange}
                value={formData.user_conf_pass}
              />
              {formData.user_conf_pass && formData.user_pass !== formData.user_conf_pass && (
                <div className="text-danger mt-1">Las contraseñas no coinciden</div>
              )}
            </div>

            <div className="col-lg-12 d-flex justify-content-end p-3">
              <button className="btn btn-secondary me-2" type="button" onClick={() => window.history.back()}>
                Volver
              </button>
              <button
                type="button"
                className="btn w-25 text-light"
                style={{ backgroundColor: "#8FC347" }}
                onClick={guardar}
              >
                Guardar
              </button>
            </div>
          </div>
        </form>
      </div>

      <MsgDialog
        Show={msgDlgShow}
        Title="Cambio de contraseña"
        Message={msgMensaje}
        BtnOkName="Aceptar"
        BtnNokName=""
        HandlerClickOk={() => setMsgDlgShow(false)}
        HanlerdClickNok={null}
      />
      <MsgDialog
        Show={msgDlgShowError}
        Title="Cambio de contraseña"
        Message={msgMensajeError}
        BtnOkName="Aceptar"
        BtnNokName=""
        HandlerClickOk={() => setMsgDlgShowError(false)}
        HanlerdClickNok={null}
      />
    </>
  );
};

export default AdministracionUsuariosExternosPage;